import React from 'react';

import Guidance from '../common/Guidance';
import { isGlobal } from '../../utils/collectionKinds';
import { canCreateItems, canManage, isGlobalConsumer } from '../../utils/permissions';

/**
 * THE LIVE-EDIT NOTICE (docs/plans/personal-discover-global.md §4.7, owner
 * ruling e02): a global collection is published IN PLACE, so every change is
 * visible to every keepr account at once. While the collection is published
 * or retiring, every surface where someone with write access works carries
 * this — the items page, the collection home, the item form — and the card
 * surfaces carry the stronger version, because a card change also moves what
 * other collections' lookups point at.
 *
 * Not dismissible: it is a fact about every edit, not a tip. Readers never
 * see it — it says nothing to someone who cannot change anything.
 */
export default function GlobalLiveNotice({ collection, strong = false, className = '' }) {
	if (!collection || !isGlobal(collection)) return null;
	if (isGlobalConsumer(collection)) return null;
	if (!canCreateItems(collection) && !canManage(collection)) return null;
	return (
		<Guidance
			tone="caution"
			className={['global-live-notice', className].filter(Boolean).join(' ')}
			title="This collection is global"
			why={strong
				? 'Changing a card changes what every reader sees and what other collections\' lookups point at.'
				: 'Every change is visible to every keepr account at once.'}
			links={['sharing-and-export/publish-a-collection-as-global']}
		/>
	);
}
